/**
 * TransformationPreview — inline "extracted → normalized" caption (UX4).
 * Rendered under a field when the normalize pipeline changed its extracted
 * value (`rawValue` present), so the reviewer sees the transformation in place.
 * Renders as a <span> so it can live inside MUI helperText (a <p>).
 */

import React from 'react';
import Typography from '@mui/material/Typography';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

interface TransformationPreviewProps {
  /** The pre-normalization extracted value. */
  rawValue: string;
}

const TransformationPreview: React.FC<TransformationPreviewProps> = ({ rawValue }) => (
  <Typography
    component="span"
    variant="caption"
    sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', mt: 0.25 }}
  >
    <AutoFixHighIcon sx={{ fontSize: 14 }} aria-hidden="true" />
    Extracted “{rawValue || '(empty)'}” — normalized for delivery
  </Typography>
);

export default TransformationPreview;
